var MVideo = function(){

    'use strict';

    var $ = jQuery;    
    var instances = [];
    var videoConfigured;

    function onReady() {
        $('.module.video').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    //Add Modernizr test
    Modernizr.addTest('isios', function(){
        return navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
    });

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id'),
            players = {},
            $iframe,
            $widthScreen,
            $heightScreen,
            $heightVideo,
            $widthVideo,
            $leftVideo;

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // adjust video screen resolution
        var adjustVideo = function() {
            // get height and width screen
            $widthScreen = $(window).width();
            $heightScreen = $(window).height();
           
            $('iframe#video').css({
                'height': '100%', 
                'width': '100%'
            });           

            $('.video-full').css({
                'width': '100%',
                'left' : '0px'
            }); 



        };

        var setupStop = function() {

            var $parent = $(this).parents('.module.video');
            var new_id = $parent.data('id');

            players[new_id].stopVideo();

            $parent.find('.module-video-container-wrapper').removeClass('full');
            $parent.find('.video-container').css('z-index', -1);
            $parent.find('.video-container').css('display', 'none');
            $parent.find('.text-container').css('z-index', 1);

        };


        var adjustHeight = function() {

        }

        var playVideoFull = function() {

            var $parent = $(this).parents('.module.video');
            var new_id = $parent.data('id');
            var body = $("html, body");

            if ( $parent.find('.headerVideo').length ) {
                var $aTag = $parent.find('a.headerVideo');
                if (!( $('body').hasClass('t-mobile') )) {
                    $('html,body').animate({scrollTop: $aTag.offset().top-69},'slow');
                }    
            }
            
            /*
            if ($widthScreen < 1024) {
                console.log('test aca estoy');
                $('html,body').animate({
                    scrollLeft: $leftVideo
                }, 'slow');
            }
            */

            $parent.find('.module-video-container-wrapper').addClass('full');
            $parent.find('.module.video .module-video-container.full').css('height', $heightVideo + 'px');            

            $parent.find('.video-container').css('z-index', 1000);
            $parent.find('.video-container').css('display', 'block');

            // detect if navigation is iOS
            if (Modernizr.isios) {

            } 
            else {
                players[new_id].playVideo(); 
            }
            
        };

        var configureVideoPlayers = function(){

            if(!videoConfigured){

                $( ".module.video" ).each(function( index, element ) {

                    var new_id = $(this).data('id');

                    players[new_id] = new YT.Player($(this).find(".videoframe").get(0), {
                        playerVars: { 
                            'autoplay': 1, 
                            'controls': 1 
                        },
                        events: {
                            'onStateChange':  function(event) {
                                switch (event.data) {
                                    case YT.PlayerState.ENDED:
                                        setupStop();
                                        break;
                                    case YT.PlayerState.PLAYING:
                                        $(window).resize(adjustHeight);
                                        break;
                                    case YT.PlayerState.PAUSED:
                                        break;
                                    case YT.PlayerState.ENDED:
                                        setupStop();
                                        $(window).off('resize', adjustHeight);
                                    case YT.PlayerState.BUFFERING:
                                        break;
                                }   
                            }
                        }
                    });

                    $(this).find('.play-video').on('click', playVideoFull);
                    $(this).find('.play-video-bottom').on('click', playVideoFull);
                    $(this).find('button.close-video').on('click', setupStop);

                });

                videoConfigured = true;

            }

        }

        // instance object
        var instance = {
            init: function () {

                adjustVideo();
                
                $(window).resize( function() { 
                    adjustVideo(); 
                });

                Events.subscribe('YOUTUBE_API_READY', configureVideoPlayers);

            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

MVideo();
